"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModulePage = void 0;
var ModulePage_1 = require("./ModulePage");
Object.defineProperty(exports, "ModulePage", { enumerable: true, get: function () { return __importDefault(ModulePage_1).default; } });
